import { Component, OnInit } from "@angular/core";
import { _myInfo } from "src/app/consts/my-info";
@Component({
  selector: "jps-pf-side-nav",
  templateUrl: "./pf-side-nav.component.html",
  styleUrls: ["./pf-side-nav.component.scss"],
})
export class PfSideNavComponent implements OnInit {
  myInfo = _myInfo;

  constructor() {}

  ngOnInit() {}
  ngAfterViewInit() {
    setTimeout(() => {
      this.scrollTo("portfolio-about");
    }, 1000);
  }
  scrollTo(elId) {
    let el = document.getElementById(elId);
    el.scrollIntoView({ behavior: "smooth" });
  }
}
